/** @format */

import {MouseEvent} from 'react';

import {EditOutlined} from '@mui/icons-material';
import {Box, IconButton, Typography} from '@mui/material';

import {ProjectTableInterface} from 'pages/HomeGrouping/types';

import {getStatusData} from 'pages/HomeGrouping/helpers/getStatusData';

import {ProjectStatus} from '../ProjectStatus';
import {cellClasses as classes, CellRoot as Root} from './styles';

interface Props {
  onEdit: () => void;
  data: ProjectTableInterface;
}

const ProjectCell = ({onEdit, data}: Props) => {
  const {title, tokenStatus} = data;
  const statusData = getStatusData(tokenStatus, title);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onEdit();
  };

  return (
    <Root>
      <Typography>{title}</Typography>

      <Box className={classes.rightColumn}>
        {statusData && <ProjectStatus data={statusData} />}
        <IconButton
          className={classes.editButton}
          onClick={handleClick}
          data-testid={`edit-${title}`}
        >
          <EditOutlined className={classes.editIcon} />
        </IconButton>
      </Box>
    </Root>
  );
};

export {ProjectCell};
